import { useUsersStore } from "@nextories/vue-tasks/src/store/usersStore";
import filterHelper from '@nextories/vue-tasks/src/utils/helpers/common/filter';
import moversHelper from '@nextories/vue-tasks/src/utils/helpers/movers';
import { i18n } from "@/plugins/i18n";
import { cloneWithoutReactivity } from "@nextories/vue-core-components/src/store/common";
import type { FilterQuery } from "@nextories/vue-tasks/src/types/Filters";

export const pluginTasksStore = {
  actions: {
    setInitialFilters(query?: FilterQuery) {
      const filterUsers = useUsersStore().$state.filterUsers;
      const { myTasks } = filterUsers;
      this.setBaseMainFilters(query);
      const mainFilters = this.baseMainFilters;
      // Iterate over each contactId and apply the filter
      i18n.global.tm('filters.contactId').forEach(contactId => {
        const valueToLowerCase = JSON.parse(JSON.stringify(contactId.value)).toLowerCase();
        // Construct the filter object for each contactId
        mainFilters[`main_${valueToLowerCase}`] = {
          ...mainFilters[`main_${valueToLowerCase}`],
          ...this.mainSettings,
          id: `main_${valueToLowerCase}`,
          query: {
            contact_id: [contactId.value],
            status: this.listStatusAvailable,
          },
          subFilters: {
            ...filterUsers,
            ...moversHelper.moversFilter({ notEdit: true }),
            ...filterHelper.setSubFilterEnabled(valueToLowerCase, myTasks, query),
          },
        };
      });
      // Update clientRequest filter if it's already in mainFilters
      if (mainFilters.clientRequest) {
        mainFilters.clientRequest = {
          ...mainFilters.clientRequest,
          ...this.mainSettings,
          query: {
            ...mainFilters.clientRequest.query,
            contact_id: 'COORD_CLIENT_REQUEST',
          },
        };
      }
      // Define callrequests filter
      mainFilters.callrequests = {
        ...mainFilters.today,
        ...mainFilters.callrequests,
        ...this.mainSettings,
        id: 'callrequests',
        query: {
          ...mainFilters.today.query,
          contact_id: [
            'CALLREQUEST_CLIENT_ADDRESS',
            'CALLREQUEST_CLIENT_RECALL_COORD',
            'CALLREQUEST_CLIENT_RECALL_SAV',
            'CALLREQUEST_CLIENT_SAV_POST',
            'CALLREQUEST_MOVER_RECALL_COORD',
            'CALLREQUEST_MOVER_RECALL_SAV'
          ],
        },
        subFilters: {
          ...mainFilters.clientRequest?.subFilters,
        },
      };
      // Set final filters with order
      this.setMainFilters(
        cloneWithoutReactivity(filterHelper.setOrderMainFilters(mainFilters)),
      );
    },
  },
};
